import React from "react";
import {ReactComponent as DandadSvg} from "./dandad.svg";

import "./Dandad.css";

const DandadIcon = () => (
  <div className="dandad icon">
    <DandadSvg className="base" />
  </div>
)

export default DandadIcon;
